import styled from 'styled-components';

import { mediaSize } from '../../styles';
import { Container } from '../ui-helpers';

export const NavigationRight = styled.div`
  display: flex;
  align-items: center;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const UserInfoTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-right: 12px;
`;

export const UserName = styled.span`
  color: ${props => props.theme.colors.fontLightBlack};
  font-size: 14px;
  line-height: 17px; 
  font-weight: 500; 
`;

export const UserDate = styled.span`
  font-size: 12px;
  line-height: 15px;
  color: ${props => props.theme.colors.fontLightBlue};
`;

export const UserInfoPopup = styled.div`
  margin-right: 6px;
`;

export const NavigationContainer = styled(Container)`
  display: flex;
  align-items: center; 
  width: 100%;
`;

export const Avatar = styled.img`
  width: 44px;
  height: 44px;
  border: 2px solid ${props => props.theme.colors.fontTangerine};
  border-radius: 50%;
  object-fit: cover;
`;

export const NavigationWrapper = styled.div`
  max-height: 66px;
  padding: 12px 35px;
  display: flex;
  justify-content: center;
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  overflow-x: hidden;

  @media (max-width: ${mediaSize.phone}) {
    ${UserDate} {
      display: none;
    }
  }
`;

export const ButtonS = styled.button`
  color: ${props => props.theme.colors.red};
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const BurgerButton = styled.button`
  display: none;

  @media (max-width: ${mediaSize.desktop}) {
    border: none;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    margin-right: 25px;

    span {
      height: 4px;
      width: 30px;
      border-radius: 10px;
      background-color: ${props => props.theme.colors.tangerinePrimary};
      font-size: 0;
      margin: 2px 0;
    }
  }
`;

export const SearchWrap = styled.div`
  flex: 1;
  margin-right: 50px;
`;



// WEBPACK FOOTER //
// ./src/components/navigation/styled-components.js